module.exports = __webpack_public_path__ + "img/section3.2944e42d.jpg";